module.exports = __webpack_public_path__ + "img/6.3ba06787.jpg";